import { useEffect } from "react";
import { useAappContext } from "../context/AppContext";

const SingelNewEvent = (props) => {
  const{getApiHost,ApiHost}=useAappContext()
  useEffect(()=>{
    getApiHost()
  },[])
  const {article,image}=props;
  return (
    <div>
      <div className="newses">
            <p>{article}</p>
            <img src={`${ApiHost}${image}`} alt="news images" />
          </div>
    </div>
  )
}

const NewsTitle=(news)=>{
  const{getApiHost,ApiHost}=useAappContext()
  useEffect(()=>{
    getApiHost()
  },[])
  const{title,description,image}=news;
return(
  <>
   <h2 className="news-title">{title}</h2>
    <p className="newsdescription">{description}</p>
      <img src={`${ApiHost}${image}`} alt="news image" />
  </>
)
}

export {SingelNewEvent, NewsTitle} 